import ChequeStatsWidget from "./ChequeStatsWidget";

export default ChequeStatsWidget;